 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		21: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"53fcc3227833a706849ec975df9070da32d5c647","3":"9c42d6f514eed8012b124063fdd7b480e3fd77de","4":"e2256ae85fdd7d54559b8dcdbfedc06580628148","5":"06b158e49dadc496d4cf8e55bff10656af214fdf","6":"fb5f3c4b2cf12ed3f86bc58f57c51e33d6a7f152","7":"61628c5c8abee406f74cd8a10b757e439e137046","8":"d6a9949e","9":"f9fffa1bd84bc1a62253931e27e92dba5dcaf919","10":"0eceb729","11":"5ab01cd3af702fdf10c9176e536c75927995afaa","12":"66d6f8f528876e36f4b9de4efda002ed764e2fd7","14":"1a0f24eb","15":"368aecf4240697ddeb2db28fc8549b6e0d88c98f","16":"4072747d","17":"46d01440d81fb82272ce2cc4fca454f705f5dc54","18":"6653e76d","19":"8fc7626d283e248fbd8b1967699da29f65f013c7","20":"component---src-pages-app-js","23":"component---src-pages-404-js","24":"component---src-pages-admin-js","25":"component---src-pages-h-2-h-fixts-js","26":"component---src-pages-h-2-h-js","27":"component---src-pages-index-js","28":"component---src-pages-inner-circle-js","29":"component---src-pages-league-list-js","30":"component---src-pages-player-stats-js","31":"component---src-pages-skyff-js","32":"component---src-pages-stats-js","33":"component---src-pages-team-stats-js","34":"component---src-pages-ucl-js","35":"component---src-pages-videprinter-js","36":"component---src-pages-videprinter-old-js","37":"component---src-templates-leagues-h-2-h-fixts-js","38":"component---src-templates-leagues-page-h-2-h-js","39":"component---src-templates-leagues-page-js","42":"polyfills-core-js","43":"polyfills-css-shim","44":"polyfills-dom"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"59e89cf2cf02423a7fa1","2":"e0a24483acb41a6c41fc","3":"d5631f6222dd18efad2d","4":"05445f6059684812c5bc","5":"b07e1bee827201a5bee9","6":"83525bb97df909f4860e","7":"68f602d87db0fe2a1bf1","8":"4f01fa957b454ce23c82","9":"5bbf371fe4834991abbc","10":"6cc59ee17df987403c29","11":"00c912af45434db4e4fb","12":"669296c01ac6d407a72f","13":"028068322e31a41e17cc","14":"be18bf87e1a64740abe5","15":"c7495fa2dab4a7244f22","16":"ffaabcda01c9d70f3a7b","17":"767b011f7ddd1e5f5050","18":"fa1fe06fdf940bd2bc8b","19":"ae6469af401133d1d1f6","20":"8ccf4b4bf8a03fb576db","23":"a825e992ae0883a66f07","24":"8cfbfe890a0dda8d03d9","25":"5388a5e0c35856972d8e","26":"26195ae7779f80602d47","27":"342f217743eadf6a0e1c","28":"ee1d86e0d7146f0963c5","29":"43b4c75f9db59c7518f3","30":"666668ff6e32565b22e5","31":"65803f8183990c498653","32":"8cb29c60bc8fc2e258d6","33":"e6110ad5179ec646c196","34":"eb0946671f6589829504","35":"22a6231305d4761b86b8","36":"24a8c0173df5df1266bd","37":"76aae4988a014ec2a6d5","38":"9e8a807464c7b300d81f","39":"a78701306ef365e28bff","42":"d6154b99b299b7320a75","43":"c82aca84f0e21845fbfb","44":"f6b6340e68fff3a1daf1","45":"15fbd5b2a27b20662d22","46":"8948b276d4afe997fa5f","47":"91136e495f6b5f895fb5","48":"cd544cce7edee0f0bc40","49":"03504e665ced95030ea0","50":"effaf6033a2c478c70ba","51":"93c868ba8bb48b1db6e0","52":"f0830d54955f42768684","53":"44ef5ef7610c5365cbf5","54":"5478ad3fb18fdc99b224","55":"42b6321c1fa33d50a899","56":"4f70125d4b073562e6f0","57":"243350b64dbb9b1184fd","58":"ce480f241ba7d0b07414","59":"5be08512910b9c50d7f2","60":"7746e5e9e5d8828cf18a","61":"7c3f5490a7da8a173ee8","62":"cb0e28cbe9ace5ef956f","63":"1f3fb18792f630f6ee01","64":"7cd9fc40d5b602b38379","65":"ca344217a7611f893652","66":"876fa294c2749c9814f8","67":"c68bd344e3f1064e74c4","68":"96a73ef14ef40610e87b","69":"98180b1d61c320f034a4","70":"d6fdb93b01150c858cc4","71":"5afa0c7606176fdcbfc1","72":"8af2fdaa21ca8992262f","73":"0d80f92d3e1e4d689910"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"53fcc3227833a706849ec975df9070da32d5c647","3":"9c42d6f514eed8012b124063fdd7b480e3fd77de","4":"e2256ae85fdd7d54559b8dcdbfedc06580628148","5":"06b158e49dadc496d4cf8e55bff10656af214fdf","6":"fb5f3c4b2cf12ed3f86bc58f57c51e33d6a7f152","7":"61628c5c8abee406f74cd8a10b757e439e137046","8":"d6a9949e","9":"f9fffa1bd84bc1a62253931e27e92dba5dcaf919","10":"0eceb729","11":"5ab01cd3af702fdf10c9176e536c75927995afaa","12":"66d6f8f528876e36f4b9de4efda002ed764e2fd7","14":"1a0f24eb","15":"368aecf4240697ddeb2db28fc8549b6e0d88c98f","16":"4072747d","17":"46d01440d81fb82272ce2cc4fca454f705f5dc54","18":"6653e76d","19":"8fc7626d283e248fbd8b1967699da29f65f013c7","20":"component---src-pages-app-js","23":"component---src-pages-404-js","24":"component---src-pages-admin-js","25":"component---src-pages-h-2-h-fixts-js","26":"component---src-pages-h-2-h-js","27":"component---src-pages-index-js","28":"component---src-pages-inner-circle-js","29":"component---src-pages-league-list-js","30":"component---src-pages-player-stats-js","31":"component---src-pages-skyff-js","32":"component---src-pages-stats-js","33":"component---src-pages-team-stats-js","34":"component---src-pages-ucl-js","35":"component---src-pages-videprinter-js","36":"component---src-pages-videprinter-old-js","37":"component---src-templates-leagues-h-2-h-fixts-js","38":"component---src-templates-leagues-page-h-2-h-js","39":"component---src-templates-leagues-page-js","42":"polyfills-core-js","43":"polyfills-css-shim","44":"polyfills-dom"}[chunkId]||chunkId) + "." + {"0":"48d054aa49a7df099e0a","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
